module.exports = __webpack_public_path__ + "amcharts/images/pencilIconH.svg";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/pencilIconH.svg
// module id = 281
// module chunks = 0